import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { SummerInternshipsRoutingModule } from './summer-internships-routing.module';
import { SummerInternshipsListComponent } from './summer-internships-list/summer-internships-list.component';
import { SummerInternshipsCreateComponent } from './summer-internships-create/summer-internships-create.component';

@NgModule({
  declarations: [SummerInternshipsListComponent, SummerInternshipsCreateComponent],
  imports: [
    CommonModule,
    SummerInternshipsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class SummerInternshipsModule { }
